import { request } from '@/common/utils/request'
import { getBDCountry, getBDTimezone } from '@/common/utils/i18n'
export const getCommonParams = function () {
  return {
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}

export default {
  getShopRankConfig(params) {
    return request.post({
      url: 'feidian.config.getConfig',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getHomepageRankingList(params) {
    return request.get({
      url: 'feidian.bdapp.bizopp.getHomepageRankingList',
      params: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
}
